// Unique local SEO content per service-area city. Service areas only — no
// physical office addresses. No invented reviews/stats/claims.
export const CITIES = [
  {
    slug: "cleaning-services-everett-wa",
    name: "Everett",
    region: "Snohomish County",
    title: "Cleaning Services in Everett, WA | Explus Cleaning LLC",
    description:
      "Professional house cleaning, deep cleaning and move-in/move-out cleaning in Everett, WA. Fully insured, locally owned. Free estimates from Explus Cleaning LLC — call (253) 534-6626.",
    h1: "Cleaning Services in Everett, WA",
    intro: [
      "As the Snohomish County seat, Everett blends historic Bayside and Riverside homes with newer waterfront condos and busy rental properties. Explus Cleaning LLC helps Everett homeowners, renters and businesses keep those very different spaces spotless with dependable, detail-focused cleaning.",
      "Whether you own an older character home that needs a careful deep clean or manage a downtown rental that needs a fast, reliable turnover, our local team tailors the visit to your property and schedule.",
    ],
    local:
      "Everett's mix of long-time family homes, apartments near the waterfront and small offices means no two jobs look alike — so we build a cleaning plan around each space rather than a one-size-fits-all checklist.",
    emphasis: [
      { name: "Residential & House Cleaning", blurb: "Regular upkeep for Everett houses, condos and apartments." },
      { name: "Move-In / Move-Out Cleaning", blurb: "Turnover-ready results for tenants, owners and landlords." },
      { name: "Airbnb Turnover Cleaning", blurb: "Fast resets for short-term rentals near the waterfront." },
    ],
    nearby: ["Mukilteo", "Mill Creek", "Lynnwood"],
  },
  {
    slug: "cleaning-services-lynnwood-wa",
    name: "Lynnwood",
    region: "Snohomish County",
    title: "House Cleaning Services in Lynnwood, WA | Explus Cleaning LLC",
    description:
      "Reliable house cleaning, deep cleaning and apartment move-out cleaning in Lynnwood, WA. Fully insured and locally owned. Get a free estimate from Explus Cleaning LLC — (253) 534-6626.",
    h1: "Cleaning Services in Lynnwood, WA",
    intro: [
      "Lynnwood is one of the fastest-growing communities in south Snohomish County, with a busy retail core around Alderwood, expanding transit and a mix of family homes, townhomes and apartment complexes. Explus Cleaning LLC keeps these homes and rentals fresh for busy Lynnwood households.",
      "From weekly and biweekly upkeep for families to detailed move-out cleans for apartments and townhomes, we handle the cleaning so you can focus on everything else.",
    ],
    local:
      "With so many apartments and townhomes changing hands in Lynnwood, move-in/move-out cleaning is one of our most requested services here — helping renters get deposits back and landlords turn units quickly.",
    emphasis: [
      { name: "Recurring House Cleaning", blurb: "Weekly, biweekly and monthly plans for busy families." },
      { name: "Move-In / Move-Out Cleaning", blurb: "Deposit-ready cleans for apartments and townhomes." },
      { name: "Deep Cleaning", blurb: "Top-to-bottom reset for homes that need extra attention." },
    ],
    nearby: ["Edmonds", "Mill Creek", "Bothell"],
  },
  {
    slug: "cleaning-services-edmonds-wa",
    name: "Edmonds",
    region: "Snohomish County",
    title: "Cleaning Services in Edmonds, WA | Explus Cleaning LLC",
    description:
      "House cleaning, deep cleaning and interior window cleaning in Edmonds, WA. Fully insured, locally owned. Request a free estimate from Explus Cleaning LLC — call (253) 534-6626.",
    h1: "Cleaning Services in Edmonds, WA",
    intro: [
      "Edmonds is known for its walkable waterfront downtown, the ferry terminal and a stock of well-kept character homes with views of Puget Sound. Explus Cleaning LLC helps Edmonds residents and small downtown businesses keep those spaces bright and welcoming.",
      "Because many Edmonds homes are built around their views and natural light, we pay special attention to interior windows, glass and surfaces that let that light in.",
    ],
    local:
      "For view homes and condos near the water, interior window cleaning and detailed dusting make a big difference — and they're a natural add-on to our regular and deep cleaning visits in Edmonds.",
    emphasis: [
      { name: "Residential Cleaning", blurb: "Careful upkeep for Edmonds homes and condos." },
      { name: "Interior Window Cleaning", blurb: "Streak-free glass to keep those Sound views clear." },
      { name: "Office Cleaning", blurb: "Dependable service for downtown Edmonds businesses." },
    ],
    nearby: ["Lynnwood", "Mukilteo", "Seattle"],
  },
  {
    slug: "cleaning-services-mukilteo-wa",
    name: "Mukilteo",
    region: "Snohomish County",
    title: "House Cleaning Services in Mukilteo, WA | Explus Cleaning LLC",
    description:
      "Professional house cleaning, deep cleaning and Airbnb turnover cleaning in Mukilteo, WA. Fully insured and locally owned. Free estimates from Explus Cleaning LLC — (253) 534-6626.",
    h1: "Cleaning Services in Mukilteo, WA",
    intro: [
      "Mukilteo pairs a scenic waterfront and ferry landing with quiet, upscale hillside neighborhoods near Paine Field. Explus Cleaning LLC provides thorough, respectful cleaning for these homes and the short-term rentals that host visitors passing through.",
      "Our team is comfortable with larger homes that need a detailed deep clean as well as quick, reliable turnovers between guests.",
    ],
    local:
      "With travelers using the ferry and Paine Field, Airbnb and vacation-rental turnovers are common in Mukilteo — we make sure each property is guest-ready on a tight timeline.",
    emphasis: [
      { name: "Deep Cleaning", blurb: "Detailed, top-to-bottom cleaning for larger homes." },
      { name: "Airbnb Turnover Cleaning", blurb: "Guest-ready resets between short-term stays." },
      { name: "Residential Cleaning", blurb: "Recurring upkeep for hillside and waterfront homes." },
    ],
    nearby: ["Everett", "Edmonds", "Lynnwood"],
  },
  {
    slug: "cleaning-services-mill-creek-wa",
    name: "Mill Creek",
    region: "Snohomish County",
    title: "Cleaning Services in Mill Creek, WA | Explus Cleaning LLC",
    description:
      "Recurring house cleaning, deep cleaning and move-out cleaning in Mill Creek, WA. Fully insured, locally owned. Get a free estimate from Explus Cleaning LLC — (253) 534-6626.",
    h1: "Cleaning Services in Mill Creek, WA",
    intro: [
      "Mill Creek is a planned, family-oriented community centered on its Town Center, with tidy neighborhoods, HOAs and plenty of two-income households. Explus Cleaning LLC helps Mill Creek families keep their homes consistently clean without adding to a packed schedule.",
      "Recurring weekly and biweekly service is especially popular here, keeping kitchens, bathrooms and living areas guest-ready year-round.",
    ],
    local:
      "For Mill Creek's newer homes and well-maintained neighborhoods, consistent recurring cleaning keeps things looking their best — and we're glad to work around HOA and community standards.",
    emphasis: [
      { name: "Recurring House Cleaning", blurb: "Weekly and biweekly plans for busy households." },
      { name: "Deep Cleaning", blurb: "Seasonal resets and detailed one-time cleans." },
      { name: "Move-In / Move-Out Cleaning", blurb: "Clean starts and finishes for Mill Creek homes." },
    ],
    nearby: ["Lynnwood", "Bothell", "Everett"],
  },
  {
    slug: "cleaning-services-bothell-wa",
    name: "Bothell",
    region: "Snohomish & King County",
    title: "Cleaning Services in Bothell, WA | Explus Cleaning LLC",
    description:
      "House cleaning, office/commercial cleaning and post-construction cleaning in Bothell, WA. Fully insured, locally owned. Free estimates from Explus Cleaning LLC — call (253) 534-6626.",
    h1: "Cleaning Services in Bothell, WA",
    intro: [
      "Straddling the Snohomish and King County line, Bothell has grown quickly around Canyon Park, UW Bothell and a cluster of tech and biotech offices, alongside established residential neighborhoods. Explus Cleaning LLC serves both the homes and the workplaces here.",
      "That means everything from recurring house cleaning to dependable office and commercial cleaning — plus post-construction cleanup as new homes and buildings come online.",
    ],
    local:
      "With ongoing development around Bothell, post-construction cleaning and new-home detailing are a regular part of what we do here, getting spaces dust-free and move-in ready.",
    emphasis: [
      { name: "Office & Commercial Cleaning", blurb: "Flexible schedules for Bothell businesses and offices." },
      { name: "Post-Construction Cleaning", blurb: "Dust and debris removal for new and remodeled spaces." },
      { name: "Residential Cleaning", blurb: "Regular upkeep for Bothell-area homes." },
    ],
    nearby: ["Mill Creek", "Kirkland", "Lynnwood"],
  },
  {
    slug: "cleaning-services-seattle-wa",
    name: "Seattle",
    region: "King County",
    title: "House & Apartment Cleaning Services in Seattle, WA | Explus Cleaning LLC",
    description:
      "Apartment and house cleaning, move-out cleaning, Airbnb turnovers and office cleaning in Seattle, WA. Fully insured, locally owned. Free estimates from Explus Cleaning LLC — (253) 534-6626.",
    h1: "Cleaning Services in Seattle, WA",
    intro: [
      "Seattle's dense mix of apartments, condos, townhomes and offices keeps residents and property managers busy. Explus Cleaning LLC helps Seattle professionals, renters and hosts keep compact urban spaces clean, sanitized and move-ready.",
      "From studio and one-bedroom apartments to busy short-term rentals and small offices, we work efficiently and respect tight city schedules and building access rules.",
    ],
    local:
      "In a city with constant moves and a large short-term rental market, move-out cleaning and Airbnb turnovers are among our most requested Seattle services, along with sanitizing for shared and high-traffic spaces.",
    emphasis: [
      { name: "Apartment & House Cleaning", blurb: "Efficient cleaning for city apartments and condos." },
      { name: "Airbnb Turnover Cleaning", blurb: "Reliable, on-time resets for Seattle hosts." },
      { name: "Move-Out & Sanitizing", blurb: "Deposit-ready move-outs and thorough sanitizing." },
    ],
    nearby: ["Bellevue", "Kirkland", "Edmonds"],
  },
  {
    slug: "cleaning-services-bellevue-wa",
    name: "Bellevue",
    region: "King County (Eastside)",
    title: "Cleaning Services in Bellevue, WA | Explus Cleaning LLC",
    description:
      "Detailed house cleaning, deep cleaning and office/commercial cleaning in Bellevue, WA. Fully insured, locally owned. Request a free estimate from Explus Cleaning LLC — (253) 534-6626.",
    h1: "Cleaning Services in Bellevue, WA",
    intro: [
      "Bellevue anchors the Eastside with a modern downtown of high-rise condos and offices surrounded by spacious residential neighborhoods. Explus Cleaning LLC brings careful, high-standard cleaning to Bellevue homes and workplaces alike.",
      "We're comfortable with larger homes that call for detailed deep cleaning, as well as tidy, professional office cleaning for the area's many businesses.",
    ],
    local:
      "Bellevue's larger homes and busy professional households often value a thorough deep clean and consistent recurring service, with the same attention to detail on every visit.",
    emphasis: [
      { name: "Deep Cleaning", blurb: "Meticulous, top-to-bottom cleaning for larger homes." },
      { name: "Residential Cleaning", blurb: "Consistent recurring upkeep across Bellevue." },
      { name: "Office & Commercial Cleaning", blurb: "Professional cleaning for Bellevue workplaces." },
    ],
    nearby: ["Kirkland", "Seattle", "Bothell"],
  },
  {
    slug: "cleaning-services-kirkland-wa",
    name: "Kirkland",
    region: "King County (Eastside)",
    title: "Cleaning Services in Kirkland, WA | Explus Cleaning LLC",
    description:
      "House cleaning, deep cleaning and Airbnb turnover cleaning in Kirkland, WA. Fully insured, locally owned. Free estimates from Explus Cleaning LLC — call (253) 534-6626.",
    h1: "Cleaning Services in Kirkland, WA",
    intro: [
      "Kirkland's walkable, waterfront downtown along Lake Washington is surrounded by condos, established homes and a growing base of tech offices. Explus Cleaning LLC keeps these Eastside spaces clean and comfortable for residents and hosts.",
      "Whether it's regular upkeep for a lakeside condo, a detailed deep clean, or a turnover for a waterfront rental, our team delivers reliable, careful results.",
    ],
    local:
      "With popular waterfront and downtown rentals, Airbnb turnover cleaning is a natural fit in Kirkland — paired with recurring and deep cleaning for full-time residents.",
    emphasis: [
      { name: "Residential Cleaning", blurb: "Regular upkeep for Kirkland homes and condos." },
      { name: "Airbnb Turnover Cleaning", blurb: "Guest-ready resets for waterfront and downtown rentals." },
      { name: "Deep Cleaning", blurb: "Detailed, refreshing cleans when you need a reset." },
    ],
    nearby: ["Bellevue", "Bothell", "Seattle"],
  },
];

export const CITY_BY_SLUG = Object.fromEntries(CITIES.map((c) => [c.slug, c]));
